import React from 'react';
import { TextWithCopyToClipboard } from '../../../../../misc/TextWithCopyToClipboard';
import { stylesheet } from 'typestyle';

const css = stylesheet({
  text: {
    whiteSpace: 'nowrap',
  },
  withRightMargin: {
    marginRight: 8,
  },
});

interface Props {
  location: string;
}

const parseAndFormatToSixDecimals = (input: string) => {
  const normalizedInput = input.replace(',', '.');
  const parsedNumber = parseFloat(normalizedInput);

  if (isNaN(parsedNumber)) {
    return input;
  }

  return parsedNumber.toFixed(6);
};

export const MissionWindowPanoramaLocation = ({ location }: Props) => {
  let output: React.ReactNode;
  const coordinates = location.split(/[,;]/).map((l) => l.trim());

  if (coordinates.length >= 2) {
    const latitude = [parseAndFormatToSixDecimals(coordinates[0]), coordinates[0]];
    const longitude = [parseAndFormatToSixDecimals(coordinates[1]), coordinates[1]];
    const agl = coordinates[2];

    output = (
      <>
        <span title={`Latitude: ${latitude[1]}`} className={css.withRightMargin}>
          <TextWithCopyToClipboard className={css.text} text={latitude[0]} textToCopy={latitude[1]} />
        </span>

        <span title={`Longitude ${longitude[1]}`} className={css.withRightMargin}>
          <TextWithCopyToClipboard className={css.text} text={longitude[0]} textToCopy={longitude[1]} />
        </span>

        {agl && (
          <span title="Height above ground level">
            <TextWithCopyToClipboard className={css.text} text={agl} />
          </span>
        )}
      </>
    );
  } else {
    output = <TextWithCopyToClipboard text={location} />;
  }

  return output;
};
